<template>
  <div class="device-logs-container">
    <div class="control-panel">
      <div class="control-container">
        <div class="header-info">
          <i class="el-icon-document"></i>
          <span>{{ $t('device.deviceLogs') }}</span>
        </div>
        <div class="action-wrapper">
          <el-button @click="goBack" size="small">
            <i class="el-icon-back"></i> {{ $t('common.back') }}
          </el-button>
        </div>
      </div>
    </div>

    <!-- 搜索筛选区 -->
    <el-card class="search-card" shadow="hover">
      <el-form :model="searchForm" inline size="small">
        <el-form-item :label="$t('device.operationType')">
          <el-select v-model="searchForm.operationType" :placeholder="$t('device.selectOperationType')" clearable style="width: 160px">
            <el-option
              v-for="type in operationTypes"
              :key="type.value"
              :label="type.label"
              :value="type.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('device.operationTime')">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="datetimerange"
            :range-separator="$t('common.to')"
            :start-placeholder="$t('common.startDate')"
            :end-placeholder="$t('common.endDate')"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
            style="width: 350px"
          ></el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('device.operatorName')">
          <el-input
            v-model="searchForm.operatorName"
            :placeholder="$t('device.enterOperatorName')"
            maxlength="50"
            clearable
            style="width: 160px"
          ></el-input>
        </el-form-item>

        <el-form-item class="search-btns">
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">{{ $t('common.search') }}</el-button>
          <el-button @click="handleReset" icon="el-icon-refresh">{{ $t('common.reset') }}</el-button>
          <el-button @click="handleExport" icon="el-icon-download">{{ $t('common.exportLogs') }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 日志列表表格 -->
    <el-card class="table-card mt-20" shadow="hover">
      <el-table
        v-loading="loading"
        :data="logsList"
        border
        stripe
        height="100%"
        style="width: 100%"
        size="small"
      >
        <el-table-column prop="id" :label="$t('device.logId')" width="120" align="center"></el-table-column>
        <el-table-column prop="operationType" :label="$t('device.operationType')" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="getOperationTypeColor(scope.row.operationType)">
              {{ getOperationTypeName(scope.row.operationType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="operationDesc" :label="$t('device.operationDesc')" min-width="200" align="left"></el-table-column>
        <el-table-column prop="deviceName" :label="$t('device.deviceName')" width="150" align="center"></el-table-column>
        <el-table-column prop="macAddress" :label="$t('device.deviceMac')" width="180" align="center"></el-table-column>
        <el-table-column prop="operatorName" :label="$t('device.operatorName')" width="100" align="center"></el-table-column>
        <el-table-column prop="operatorIp" :label="$t('common.ip')" width="150" align="center"></el-table-column>
        <el-table-column prop="operationTime" :label="$t('device.operationTime')" width="180" align="center">
          <template slot-scope="scope">
            <span>{{ formatDate(scope.row.operationTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('device.operationStatus')" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'success' ? 'success' : 'danger'">
              {{ scope.row.status === 'success' ? $t('common.success') : $t('common.fail') }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页控件 -->
      <div class="pagination-section">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'DeviceLogs',
  data() {
    return {
      deviceId: this.$route.params.id,
      logsList: [],
      loading: false,
      searchForm: {
        operationType: '',
        dateRange: [],
        operatorName: ''
      },
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      operationTypes: [
        { label: this.$t('device.deviceBind'), value: 'device_bind' },
        { label: this.$t('device.deviceUnbind'), value: 'device_unbind' },
        { label: this.$t('device.deviceUpdate'), value: 'device_update' },
        { label: this.$t('device.firmwareUpdate'), value: 'firmware_update' },
        { label: this.$t('device.deviceRestart'), value: 'device_restart' },
        { label: this.$t('device.configChange'), value: 'config_change' },
        { label: this.$t('device.statusQuery'), value: 'status_query' }
      ]
    }
  },
  created() {
    this.fetchDeviceLogs()
  },
  methods: {
    fetchDeviceLogs() {
      this.loading = true
      const params = {
        deviceId: this.deviceId,
        operationType: this.searchForm.operationType,
        startTime: this.searchForm.dateRange && this.searchForm.dateRange[0],
        endTime: this.searchForm.dateRange && this.searchForm.dateRange[1],
        operatorName: this.searchForm.operatorName,
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      }
      this.$store.dispatch('deviceManagement/fetchDeviceLogs', params).then(response => {
        this.logsList = response.logs
        this.pagination.total = response.total
      }).catch(error => {
        this.$message.error(this.$t('device.getLogsFailed') + '：' + error.message)
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchDeviceLogs()
    },
    handleReset() {
      this.searchForm = {
        operationType: '',
        dateRange: [],
        operatorName: ''
      }
      this.pagination.page = 1
      this.fetchDeviceLogs()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchDeviceLogs()
    },
    handleCurrentChange(current) {
      this.pagination.page = current
      this.fetchDeviceLogs()
    },
    handleExport() {
      this.$confirm(this.$t('device.confirmExportLogs'), this.$t('common.prompt'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'info'
      }).then(() => {
        // 调用导出接口
        this.$message.success(this.$t('device.exportLogsSuccess'))
      }).catch(error => {
        if (error !== 'cancel') {
          this.$message.error(this.$t('device.exportLogsFailed') + '：' + error.message)
        }
      })
    },
    // 返回设备详情
    goBack() {
      this.$router.push(`/device/detail/${this.deviceId}`)
    },
    getOperationTypeColor(type) {
      const colorMap = {
        'device_bind': 'success',
        'device_unbind': 'danger',
        'device_update': 'warning',
        'firmware_update': 'primary',
        'device_restart': 'info',
        'config_change': 'success',
        'status_query': 'info'
      }
      return colorMap[type] || 'default'
    },
    getOperationTypeName(type) {
      const typeMap = this.operationTypes.reduce((map, item) => {
        map[item.value] = item.label
        return map
      }, {})
      return typeMap[type] || type
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString(this.$i18n.locale === 'zh-CN' ? 'zh-CN' : 'en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.device-logs-container {
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.control-panel {
  margin-bottom: 24px;
  flex-shrink: 0;
}

.control-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #303133;
  font-size: 16px;
  font-weight: 500;
  
  i {
    font-size: 20px;
    color: #409eff;
  }
}

.action-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-card {
  margin-bottom: 20px;
  border-radius: 8px;
  flex-shrink: 0;
}

.table-card {
  border-radius: 8px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  :deep(.el-card__body) {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 20px;

    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: #e4e7ed;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }
}

.mt-20 {
  margin-top: 20px;
}

.search-btns {
  margin-left: 20px;
}

.pagination-section {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
  flex-shrink: 0;
}

@media screen and (max-width: 768px) {
  .control-container {
    flex-direction: row;
    align-items: center;
  }
  
  .header-info span {
    display: none;
  }

  .el-form-item {
    width: 100%;
    margin-right: 0 !important;
  }

  .el-select, .el-input, .el-date-editor {
    width: 100% !important;
  }

  .search-btns {
    margin-left: 0;
    width: 100%;
    justify-content: flex-end;
  }
}
</style>